// taken from "get all feature flags" request
export enum FeatureFlagEnum {
  HIDDEN_DELETE_BUTTON = "stealth-dbtn",
}

export type FeatureFlag = {
  id: string;
  name: FeatureFlagEnum;
  enabled: boolean;
};
